export default __webpack_public_path__ + "static/media/jacket.3be7eff1.png";